import React, { useEffect, useState } from 'react';

import Head from 'next/head';

import {
  placeHolderRatio16X9,
  playerPlaceHolderContent
} from 'src/styles/styles';

import { useAppStore } from 'src/hooks/useAppStore';
import { DEVICE_TYPES } from 'src/utils/constants/AppConstants';
import { BannerAPIContentType } from '../../../services/responseTypes/BannerApiResponse';
import { TAG_NAME } from '../../../utils/constants/TagNameConstants';
import {
  getImageURL,
  reduceImageDimension
} from '../../../utils/ImageHelper/ImageURLGenerator';
import { playerBot, playerWrapper } from './PlayerStyles';

interface PlayerPlaceholderProps {
  isRequestedBySearchBot: boolean;
  children: React.ReactNode;
  assetDetails?: BannerAPIContentType;
}

export const PlayerPlaceholder: React.FC<PlayerPlaceholderProps> = ({
  isRequestedBySearchBot,
  children,
  assetDetails
}) => {
  const [isClient, setIsClient] = useState(false);

  const deviceWidth = useAppStore().appConfig.deviceWidth as number;
  const deviceType = useAppStore().appConfig.actualDeviceType;
  const isMobile = deviceType === DEVICE_TYPES.MOBILE;
  const [placeholderImageUrl, setPlaceholderImageUrl] = useState(
    assetDetails && isRequestedBySearchBot && !isMobile
      ? reduceImageDimension(
          getImageURL({
            deviceWidth,
            isRequestedByBot: isRequestedBySearchBot,
            item: assetDetails,
            tagName: TAG_NAME.PLAYER_POSTER
          })
        )
      : ''
  );

  const renderPlaceholder = () => {
    if (isRequestedBySearchBot && isMobile) {
      return (
        <div css={playerWrapper}>
          <div className="playerContentWrapper content">
            <div className="playerContainer"></div>
          </div>
        </div>
      );
    }

    if (isRequestedBySearchBot) {
      return (
        <figure css={placeHolderRatio16X9}>
          <div css={playerPlaceHolderContent}>
            <img
              css={playerBot}
              src={placeholderImageUrl}
              alt={assetDetails?.title}
              // onError={(i) => (i.target.className = 'errImgDisplay')}
            />
          </div>
        </figure>
      );
    }
    return <React.Fragment>{children}</React.Fragment>;
  };

  useEffect(() => {
    if (
      isRequestedBySearchBot &&
      !isMobile &&
      assetDetails &&
      !placeholderImageUrl
    ) {
      const placeholderImageUrl = reduceImageDimension(
        getImageURL({
          deviceWidth,
          isRequestedByBot: isRequestedBySearchBot,
          item: assetDetails,
          tagName: TAG_NAME.PLAYER_POSTER
        })
      );
      setPlaceholderImageUrl(placeholderImageUrl);
    }
  }, [assetDetails]);

  useEffect(() => {
    setIsClient(true);
  }, []);

  return (
    <>
      {isRequestedBySearchBot && !isMobile && placeholderImageUrl && !isClient && (
        <Head>
          <link
            rel="preload"
            href={placeholderImageUrl}
            as="image"
            type="image/webp"
            {...{ fetchpriority: 'high' }}
          />
        </Head>
      )}
      <div css={playerWrapper}>
        <div className="figureTeaserBannerWrapper">{renderPlaceholder()}</div>
      </div>
    </>
  );
};
